import { IconButton } from "native-base";
import React from "react";
import { StyleSheet } from "react-native";
import { faChartLine } from "../../assets/consts/faCharCodes";
import Theme from "../argon-ui/Theme";
import { IS_MOBILE } from "../locales/translate";
import FontAwesomeIcon from "./FontAwesomeIcon";

type PropsType = {
  onPress: () => void;
};

const LogIconButton = (props: PropsType) => {
  return (
    <IconButton
      variant="ghost"
      style={[styles.btnIcon, IS_MOBILE && styles.bgBtnIcon]}
      onPress={props.onPress}
      icon={
        <FontAwesomeIcon
          icon={faChartLine}
          color={Theme.COLORS.MUTED}
          size={16}
        />
      }
    />
  );
};
const styles = StyleSheet.create({
  bgBtnIcon: {
    backgroundColor: Theme.COLORS.WHITE,
  },
  btnIcon: {
    borderRadius: 10,
    padding: 0,
    width: 40,
    height: 40,
    // shadowColor: Theme.COLORS.INPUT,
    // shadowOffset: {
    //   width: 0,
    //   height: 6,
    // },
    // shadowOpacity: 0.3,
    // shadowRadius: 6.65,
    // elevation: 9,
    shadowColor: Theme.COLORS.MUTED,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.2,
    shadowRadius: 6.65,
    elevation: 4,
  },
});
export default LogIconButton;
